import * as React from "react";
import { db } from "../../firebase";
import { Radio, Form , Dropdown , Button } from 'semantic-ui-react'

interface InterfaceProps {
  error?: any;
  history?: any;
  categoryName?: string;
  categoryPriority?: string;
  tags?: any[];
  relatedTags?: any[];
  onCategoryAdded: any;
  onModalClosed : any

}

interface InterfaceState {
  error?: any;
  categoryName?: string;
  categoryPriority?: string;
  relatedTags?: any[];
}

export class CategoryAddForm extends React.Component<
  InterfaceProps,
  InterfaceState
> {
  private static INITIAL_STATE = {
    error: null,
    categoryName: "",
    categoryPriority: null,
    relatedTags: []
  };

  private static propKey(propertyName: string, value: string): object {
    return { [propertyName]: value };
  }

  constructor(props: any) {
    super(props);
    this.state = { ...CategoryAddForm.INITIAL_STATE };
  }

  public onSubmit = (event: any) => {
    const { categoryName, categoryPriority, relatedTags }: any = this.state;
     const { onCategoryAdded } = this.props;
     const generatedId = db.generateRandomId()
     db.doCreateCategoryWithTags(generatedId ,categoryName, categoryPriority, relatedTags)
     .then(() => {
        this.setState(() => ({ ...CategoryAddForm.INITIAL_STATE }));
        onCategoryAdded()
     })
      .catch(error => {
        this.setState(CategoryAddForm.propKey("error", error));
      }); 

    event.preventDefault();
  };


public handlechange = (value: any) =>{

  const { tags }: any = this.props;
  const tagList = value.map((item) => {
    return tags[item]
  })
      this.setState({
      relatedTags: tagList
    });
}
  public render() {
    const { categoryName, relatedTags, categoryPriority,error }: any = this.state;
    const { tags, onModalClosed}: any = this.props;
    const tagOptions = Object.keys(tags).map(key => ({ key, value: key, text: tags[key].text }));
    const isInvalid = categoryName === "" || relatedTags.length == 0 || categoryPriority === null

    return (
        <Form  onSubmit={event => this.onSubmit(event)}>
          <Form.Field>
            <label>Category Name</label>
            <input
              value={categoryName}
              onChange={event => this.setStateWithEvent(event, "categoryName")}
              type="text"
              placeholder="Category Name"
            />
          </Form.Field>
          <Form.Group inline>
            <label>Order : </label>
            <Form.Field
              control={Radio}
              label='Top'
              value={1}
              checked={categoryPriority === 1}
              onChange={(e , { value }) => this.handlePrioritychange(value)}
            />
            <Form.Field
              control={Radio}
              label='Medium'
              value={2}
              checked={categoryPriority === 2}
              onChange={(e , { value }) => this.handlePrioritychange(value)}
            />
            <Form.Field
              control={Radio}
              label='Basic'
              value={3}
              checked={categoryPriority === 3}
              onChange={(e , { value }) => this.handlePrioritychange(value)}
            />
          </Form.Group>
          <Form.Field>
            <label>Related Tags</label>
            <Dropdown 
                name='relatedTags'
                placeholder='Tags' 
                onChange={(e , { value }) => this.handlechange(value)}
                fluid multiple search selection 
                options={tagOptions} />
          </Form.Field>
          <Button type='submit' disabled={isInvalid} positive>Save</Button>
          <Button onClick={onModalClosed} primary>Dismiss</Button>
          {error && <p>{error.message}</p>}
        </Form>
    );
  }

  private setStateWithEvent(event: any, columnType: string): void {
    this.setState(
      CategoryAddForm.propKey(columnType, (event.target as any).value)
    );
  }

  private handlePrioritychange = (value: any) => this.setState({ categoryPriority : value })

}


// WEBPACK FOOTER //
// ./src/pills/categories/categoryAddForm.tsx